export enum SWRKeysEnum {
  CONTINUE_CAPTURE_PROCESS = 'continue-capture-process',
}
